import { useEffect, useState } from "react";
import { Row, Col } from "antd";

const AddressRow = ({
  equal,
  noMargin,
  secondIcon,
  secondBigger,
  firstChildren,
  secondChildren,
}) => {
  const [firstDimensions, setFirstDimensions] = useState();
  const [secondDimensions, setSecondDimensions] = useState();
  useEffect(() => {
    setFirstDimensions({
      xl: equal ? 11 : secondBigger ? 8 : secondIcon ? 21 : 13,
      xs: 24,
    });
    setSecondDimensions({
      xl: {
        span: equal ? 11 : secondBigger ? 14 : secondIcon ? 1 : 9,
        offset: 2,
      },
      xs: 24,
    });
  }, [equal, secondIcon, secondBigger, noMargin]);

  return (
    <Row>
      <Col span={24}>
        <Row align="middle">
          <Col {...firstDimensions}>{firstChildren}</Col>
          <Col {...secondDimensions}>{secondChildren}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AddressRow;
